import { useParams } from 'react-router-dom'
import { MemberDetailPage } from '@/components/members/member-detail-page'

export function OperationsMemberDetail() {
  const { id } = useParams<{ id: string }>()
  if (!id) return null

  return (
    <MemberDetailPage
      memberId={id}
      listPath="/operations/members"
      canDelete
      canManageRole={false}
      canManagePlots
      plotsBasePath="/operations/plots"
    />
  )
}
